document.addEventListener('DOMContentLoaded', function () {
    // Cerca l'anchor solo se il body ha la classe cart-empty
    if (document.body.classList.contains('cart-empty')) {

        const link = document.querySelector('#cart-icon-menu a');

        if (link) {
            link.classList.add('popup-cart');
            link.setAttribute('href', '#');
        }
    }
});



// WEBPACK FOOTER //
// ./js/widget/popup-cart.js